export function getFilterOptions(products, field) {
  const values = [...new Set(products.map((product) => product[field]).filter(Boolean))]
  // Custom sort for Sterilised: Yes before No
  if (field === 'sterilised') {
    const order = { Yes: 0, No: 1 }
    values.sort((a, b) => {
      const ao = order[a] ?? 99
      const bo = order[b] ?? 99
      if (ao !== bo) return ao - bo
      return String(a).localeCompare(String(b))
    })
  } else if (field === 'size') {
    // Breed Size logical order: very small → small → medium → large → giant
    const sizeOrder = { 'very small': 0, small: 1, medium: 2, large: 3, giant: 4 }
    values.sort((a, b) => {
      const ao = sizeOrder[String(a).toLowerCase()] ?? 99
      const bo = sizeOrder[String(b).toLowerCase()] ?? 99
      if (ao !== bo) return ao - bo
      return String(a).localeCompare(String(b))
    })
  } else if (field === 'age') {
    // Life Stage logical order: Kitten/Puppy → Older puppy/Junior → Adult → Mature → Senior
    const ageOrder = {
      kitten: 0,
      puppy: 0,
      'older puppy': 1,
      junior: 2,
      adult: 3,
      mature: 4,
      senior: 5,
    }
    values.sort((a, b) => {
      const ao = ageOrder[String(a).toLowerCase()] ?? 99
      const bo = ageOrder[String(b).toLowerCase()] ?? 99
      if (ao !== bo) return ao - bo
      return String(a).localeCompare(String(b))
    })
  } else {
    values.sort((a, b) => String(a).localeCompare(String(b)))
  }
  return ['All', ...values]
}

export function filterProducts(products, searchTerm, filters) {
  // Support both signatures: (products, filters) and (products, searchTerm, filters)
  let term = ''
  let filterObj = {}

  if (typeof searchTerm === 'string') {
    term = searchTerm
    filterObj = filters || {}
  } else if (typeof searchTerm === 'object' && searchTerm !== null) {
    filterObj = searchTerm
    term = ''
    if (filters && typeof filters === 'object') {
      filterObj = filters
    }
  } else {
    filterObj = filters || {}
  }

  let result = products
  if (term && term.trim() !== '') {
    const lowerTerm = String(term).toLowerCase()
    result = result.filter((product) => {
      const haystack = [
        product.name,
        product.description,
        product.id,
        product.breed,
        product.category,
        product.needs,
        product.age,
        product.brand,
        product.brands,
        product.size,
        product.sterilised,
        product.productSize,
        product.additionalInfo?.brands,
        product.additionalInfo?.brand,
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase()
      return haystack.includes(lowerTerm)
    })
  }

  if (!filterObj || Object.keys(filterObj).length === 0) return result

  return result.filter((product) =>
    Object.entries(filterObj).every(
      ([field, value]) => value === 'All' || value === undefined || product[field] === value
    )
  )
}

export function sortProducts(
  products,
  sortBy,
  { nameField = 'name', priceField = 'price' } = {}
) {
  return [...products].sort((a, b) => {
    switch (sortBy) {
      case 'price-asc':
        return a[priceField] - b[priceField]
      case 'price-desc':
        return b[priceField] - a[priceField]
      case 'name-desc':
        return String(b[nameField]).localeCompare(String(a[nameField]))
      default:
        return String(a[nameField]).localeCompare(String(b[nameField]))
    }
  })
}

export function filterAndSortProducts(
  products,
  { filters = {}, sortBy = 'name-asc', sortOptions } = {}
) {
  return sortProducts(filterProducts(products, filters), sortBy, sortOptions)
}
